module.exports = __webpack_public_path__ + "static/tss-9178f4f22899c334c613cb11626672cc.png";